import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Collapse, CardBody, Button, CardHeader, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import StorageContainerExplorer from '../../../../../storageContainer/StorageContainerExplorer';
import InstanceClient from '../../../../../../services/InstanceClient';
import { CoreFlowSyncCsvImport } from '../../../../../../models/CoreFlowSyncCsvModels';

export const validator = (configuration: CoreFlowSyncCsvImport, active: boolean) => {
    const validation: string[] = [];

    if (active) {
        if (!configuration.blobContainerUrl || configuration.blobContainerUrl.trim() === "") {
            validation.push('blobContainerUrl');
        }

        if (!configuration.blobSourceKey || configuration.blobSourceKey.trim() === "") {
            validation.push('blobSourceKey');
        }
    }

    return validation;
}

interface FlowSyncCsvImportConfigurationProps {
    disabled: boolean,
    configuration: CoreFlowSyncCsvImport
    updatePart: (part: Partial<CoreFlowSyncCsvImport>) => void
    active: boolean
    onValidChange: (arg: boolean) => void 
}

const FlowSyncCsvImportConfiguration = (props: FlowSyncCsvImportConfigurationProps) => {
    const { t } = useTranslation(['configuration', 'common']);
    const [requiredFiles, setRequiredFiles] = useState<string[]>([]);
    const [open, setOpen] = useState<boolean>(true);

    const validation = validator(props.configuration, props.active);

    useEffect(() => {
        props.onValidChange(validation.length ? true : false)
    }, [props.configuration, props.active]);

    useEffect(() => {
        InstanceClient.get<string[]>('/api/core/flowsynccsvimportconfiguration/requiredfiles')
            .then(res => setRequiredFiles(res.data))
            .catch(error => {
                console.error(error);
                //continue as if there are no required files
            })
    }, [])

    return (
        <Card className="edit_module">
            <CardHeader tag="h2">
                <Button outline color="secondary" style={{ width: '37px', float: 'right' }} onClick={() => setOpen(!open)}>{open ? '-' : '+'}</Button>
                {t('modules.FlowSyncCsvImport.title', { ns: 'common' })}
            </CardHeader>
            <Collapse isOpen={open}>
                <CardBody>
                    <FormGroup>
                        <h5>{t('flowSyncCsvImport.access.title', { ns: 'configuration' })}</h5>
                        <FormGroup>
                            <Label for="blobContainerUrl">{t('flowSyncCsvImport.access.linkContainer', { ns: 'configuration' })}</Label>
                            <Input
                                type="text"
                                name="blobContainerUrl"
                                id="blobContainerUrl"
                                placeholder={t('flowSyncCsvImport.access.linkContainer', { ns: 'configuration' })}
                                disabled={props.disabled}
                                value={props.configuration.blobContainerUrl || ''}
                                onChange={(e) => props.updatePart({ blobContainerUrl: e.target.value })}
                                invalid={validation.indexOf('blobContainerUrl') !== -1}
                                autoComplete="off" />
                            <FormFeedback>{t('flowSyncCsvImport.access.feedbackLinkContainer', { ns: 'configuration' })}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label for="blobSourceKey">{t('flowSyncCsvImport.access.blobSourceKey', { ns: 'configuration' })}</Label>
                            <Input
                                type="text"
                                name="blobSourceKey"
                                id="blobSourceKey"
                                placeholder={t('flowSyncCsvImport.access.blobSourceKey', { ns: 'configuration' })}
                                value={props.configuration.blobSourceKey || ''}
                                disabled={props.disabled}
                                onChange={(e) => props.updatePart({ blobSourceKey: e.target.value })}
                                invalid={validation.indexOf('blobSourceKey') !== -1}
                                autoComplete="off" />
                            <FormFeedback>{t('flowSyncCsvImport.access.feedbackBlobSourceKey', { ns: 'configuration' })}</FormFeedback>
                        </FormGroup>
                        <StorageContainerExplorer
                            blobContainerUrl={props.configuration.blobContainerUrl}
                            blobSourceKey={props.configuration.blobSourceKey}
                            expectedFiles={requiredFiles} />
                    </FormGroup>
                </CardBody>
            </Collapse>
        </Card>
    )
};

export default FlowSyncCsvImportConfiguration;
